import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ShippingLabelDownloadInput')
export class ShippingLabelDownload {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('sldl') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  pdf: string

  @Field(() => String)
  @Prop({ type: String })
  png: string

  @Field(() => String)
  @Prop({ type: String })
  zpl: string
}
